import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, Input, NgZone, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';
import { environment } from 'src/environments/environment';
import { UserDetails } from 'src/app/models/user-details.model';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { WindowRefService } from 'src/app/services/razor-pay-gateway/window-ref.service';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { SubscriptionModel } from 'src/app/models/subscription-model';
import { GetActivePlanDetails } from 'src/app/pipes/get-active-plan-name/get-active-plan-name.pipe';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import  moment from 'moment';
import  subscription_page from '../../../../assets/data/subscription-page.json'
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CreditQuotaHelper } from 'src/app/constants/credit-quota.constants';
import { Subject, takeUntil, take } from 'rxjs';
import { BillingAddressService } from 'src/app/services/billing-address/billing-address.service';
import { BillingListModel } from 'src/app/models/billing-address.model';
import { AddBillingAddressFormComponent } from '../../shared/billing-addresses/add-billing-address-form/add-billing-address-form.component';

@Component({
  selector: 'ipm-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
})
export class SubscriptionComponent implements OnInit, AfterViewInit, OnDestroy {
  subsToggle: any = "annual";
  selectedPlanId: string
  subsList:Array<SubscriptionModel> = [];
  compareList:Array<SubscriptionModel> = [];
  subsFeatureList:Array<SubscriptionModel> = [];
  AllPlansList: Array<SubscriptionModel> = [];
  selectedSubsData: any = "";
  currentUserInfo: UserDetails;
  activatedSubs: CurrentActivatedPlan;
  activePlanSubscription: any = "";
  exitingPlanData: Array<any> = [];

  // Dynamic KITS22 container data
  kits22Data: any = {
    heading: 'KITS22',
    subheading: 'Get free Sound Kits under PRO plans',
    quota: 0,
    quotaLabel: '',
    availableCredits: 0,
    renewalCycle: '',
    showButton: true,
    showDetails: true,
    isLoading: true
  };

  private destroy$ = new Subject<void>();

  // Annual Offer Banner Properties
  isOfferBannerVisible: boolean = true;
  private readonly OFFER_END_DATE = new Date('2026-08-31T23:59:59');

  isLoadData: any = false;
  stats = subscription_page.stats;
  animatedStats = subscription_page.stats.map(stat => ({ ...stat, displayValue: stat.title }));
  private statsObserver: IntersectionObserver | null = null;
  private hasAnimated = false;
  features = subscription_page.features;
  clientReviews= subscription_page.clientReviews;

  activeGradients: number[] = [1, 1, 1]; // One for each feature section
  activeButtons: number[] = [0, 0, 0]; // One for each feature section
  previousButtons: number[] = [0, 0, 0]; // Track previous button for smooth transition
  slideDirections: string[] = ['', '', '']; // 'left' or 'right' for each feature section
  animatingFeatures: boolean[] = [false, false, false]; // Track animation state
  
  handleBtnClick(featureIndex: number, buttonIndex:number , gradientNumber: number  ) {
    if (this.animatingFeatures[featureIndex]) {
      return; // Prevent clicks during animation
    }
    
    const previousIndex = this.activeButtons[featureIndex];
    if (previousIndex === buttonIndex) {
      return; // Same button, no animation needed
    }
    
    const direction = buttonIndex > previousIndex ? 'left' : 'right';
    
    this.previousButtons[featureIndex] = previousIndex;
    this.slideDirections[featureIndex] = direction;
    this.animatingFeatures[featureIndex] = true;
    this.activeButtons[featureIndex] = buttonIndex;
    this.activeGradients[featureIndex] = gradientNumber;
    
    // After animation completes (600ms), reset animation state
    setTimeout(() => {
      this.animatingFeatures[featureIndex] = false;
      this.slideDirections[featureIndex] = '';
    }, 600);
  }
  customOptions: OwlOptions = {
    center: false,
    margin: 30,
    responsiveRefreshRate: 0,
    dots: true,
    dotsData: false,
    lazyLoad: true,
    mouseDrag: true,
    touchDrag: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    loop: true,
    navText: ['<i class="las la-angle-left"></i>', '<i class="las la-angle-right"></i>'],
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
        autoplay: true,
      },
      565: {
        items: 1,
        slideBy: 1,
        autoplay: true,
      },  
      767: {
        items: 2,
        slideBy: 1
      },
      992: {
        items: 3,
        slideBy: 1
      },
      1250: {
        items: 3,
        slideBy: 1
      }, 
      1900:{
        items:4,
        slideBy:1
      }
    }
  }

  @Input() componentType: any = "";
  @ViewChild('confirmationPop', { static: false }) confirmationPopTemplate: TemplateRef<any>;
  @ViewChild('cancelSubscriptionModal', { static: false }) cancelSubscriptionModal: TemplateRef<any>;
  @ViewChild('billingAddressesModel', { static: false }) billingAddressesTemplate: TemplateRef<any>;
  @ViewChild('upgradeSubscriptionModal', { static: false}) upgradePlanTemplate: TemplateRef<any>;
  @ViewChild('ContactUsSubscriptionModal', { static: false}) ContactUsSubscriptionTemplate: TemplateRef<any>;
  @ViewChild('loginAlertUserPopup', { static: false }) loginAlertUserPopup: TemplateRef<any>;
  @ViewChild('paymentSuccessPopup', { static: false }) paymentSuccessPopup: TemplateRef<any>;
  @ViewChild('statsSection', { static: false }) statsSection: ElementRef;
  @ViewChild('compareScrollContent', { static: false }) compareScrollContent: ElementRef<HTMLElement>;
  currentAddressSelected: any = "";
  addressReopenSubscription: any = null;
  couponCode: any = "IPM_INTERNAL";
  isCouponApplied: boolean = false;
  timerLeft: string;
  timerInterval: any = "";
  actualPrice: any = ""
  validTillPlan: any = "";
  isOfferApplied: boolean = true;
  isShowActivePriceDate: boolean = false;
  isFounderOffer: boolean = false;
  isCompareScrollbarVisible: boolean = false;
  compareScrollMax: number = 0;
  compareScrollValue: number = 0;
  constructor(
    private routerActivated: ActivatedRoute,
    public commonService: CommonService,
    private subscriptionService: SubscriptionService,
    private authService: AuthService,
    public ga4Tracking: Ga4trackingService,
    public browserStorageService: BrowserStorageService,
    private winRef: WindowRefService,
    private getActivePLan: GetActivePlanDetails,
    private ngZone: NgZone,
    private billingAddressService: BillingAddressService,
    private router: Router,
    private hostElement: ElementRef<HTMLElement>) {
      this.validTillPlan = moment(new Date("2025-01-23T21:29:22.770Z")).format("Do MMM yyyy");
      this.authService.currentUserDetails.subscribe((userObj: UserDetails)  => {
        if (userObj &&  Object.keys(userObj).length > 0) {
          this.currentUserInfo = userObj;
        }
      })
    }

  ngOnInit(): void {
    // Initialize annual offer banner
    this.initializeOfferBanner();
    
    if (!this.componentType) {
      if (this.currentUserInfo) {
        this.routerActivated.data.subscribe((data: Data) => {
          this.commonService.setTitleService(data['title']);
        });
      } else {
        this.setBrowsersTitle();
      }
    }
    this.subscriptionService.activeSubscription.subscribe((activeSubsResponse: CurrentActivatedPlan) => {
      if (activeSubsResponse) {
        this.activatedSubs = activeSubsResponse;
      }
    })

    this.routerActivated.queryParams.subscribe((data: Data) => {
      let selectedPlanId =  data['selectedPlanId'];
      this.getSubsData(selectedPlanId);
    });
  }

  getSubsData(selectedPlanId: any) {
    this.subscriptionService.getAllSubscriptionPlans().subscribe( (subResponse: Array<SubscriptionModel>) => {
      this.AllPlansList = subResponse;
      if (this.isOfferBannerVisible) {
        this.AllPlansList = this.AllPlansList.map((plan: SubscriptionModel) => {
          if (plan.tier === 'tier1' && plan.frequency === 'annual' && plan.isCommission) {
            plan.price = 999;
          }
          return plan;
        });
      }
      if (this.currentUserInfo) {
        this.activePlanSubscription = this.getActivePLan.transform(this.activatedSubs, this.AllPlansList, this.subscriptionService?.activeSubsPlanDetails);
      }
      if (this.activatedSubs && this.activatedSubs.activeSubscriptions.length > 0 && this.activePlanSubscription?.tier === "tier2" && this.activePlanSubscription?.isCommission) {
        this.subsToggle = this.activePlanSubscription?.frequency;
      }
      this.preparePlansList();
    }, error => {
      this.commonService.showToastError(error);
    })
  }

  updateFrequencyToggle(tierType: string): string {
    let currentFrequency: string = "monthly";
    let activatedSubsList: any =  this.activatedSubs.activeSubscriptions;
    let foundedPlans: any = this.AllPlansList.filter((item: any) => item.tier === tierType);
    let foundActivatedPLans: any = [];
    if (foundedPlans.length) {
      foundedPlans.map((findPlanObj: any) => {
        if(findPlanObj.razorpayPlanId) {
          let finalActivatedFrequency: any = activatedSubsList.find((activeSubsObj: any) =>  activeSubsObj.planId === findPlanObj.razorpayPlanId);
          if (finalActivatedFrequency) {
            foundActivatedPLans.push(finalActivatedFrequency);
          }
        }
      });
      if (foundActivatedPLans.length) {
        let isAnnual = foundActivatedPLans.some((activateObj: any) => activateObj.frequency === "annual");
        if (isAnnual) {
          currentFrequency = "annual";
        }
      }
    }
    return currentFrequency;
  }

  // Temporary: purchases are paused while plans/prices/names are being revamped. Set to false to re-enable.
  isPurchaseDisabled = false;
  purchaseDisabledMessage = "New subscription plans are coming soon. Purchases are temporarily unavailable.";

  buyPlanAction(currentPlanDetails: any, actionType: string = "") {
    if (this.isPurchaseDisabled) {
      return;
    }
    const getStartedSource = this.componentType === 'popup' ? 'subscription_popup'
      : this.componentType === 'offer' ? 'subscription_offer'
      : 'subscription_page';
    this.ga4Tracking.sendEvent('subscription_getstarted', {
      category: 'Subscription',
      label: 'Get Started',
      action: 'click',
      selected_subscription_plan: currentPlanDetails.planName || '',
      plan_tier: currentPlanDetails.tier || '',
      plan_frequency: currentPlanDetails.frequency || '',
      plan_price: currentPlanDetails.price || 0,
      source: getStartedSource,
      userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
      userId: this.browserStorageService?.getUserId() || 'guest'
    });

    if (this.currentUserInfo) {
      if (this.activePlanSubscription) {
        if (this.activePlanSubscription.tier  === 'tier0') {
            if (this.componentType === "offer") {
              this.closePopup();
            }
            this.openAddressModel(currentPlanDetails);
        } else {
          if (actionType) {
            this.openContactUsPlan();
          } else {
            this.openUpdatePlan(currentPlanDetails,'upgrade');
          }
        }
      } else {
        if (this.componentType === "popup" || this.componentType === "offer") {
          this.closePopup();
        }
        this.openAddressModel(currentPlanDetails);
      }

    } else {
      this.openAuthAlertModel();
    }
  }


  openAddressModel(currentPlanDetails: any) {
    let currentIdData: any = currentPlanDetails;
    let className = this.commonService.getClassName('ipm-billing-address-popup-model');
    this.commonService.openModel(this.billingAddressesTemplate, { currentPlanDetails :  currentIdData}, className, true);
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe((response: any) => {
        this.onCloseModelPopup(response, currentPlanDetails);
      });
    } else {
      this.commonService.modelRef.afterClosed().subscribe((response: any) => {
        this.onCloseModelPopup(response, currentPlanDetails);
      });
    }
    // Only create subscription once per checkout flow
    if (!this.addressReopenSubscription) {
      this.reOpenAddressModel(currentPlanDetails);
    }
  }

  reOpenAddressModel(currentPlanDetails: any) {
    this.addressReopenSubscription = this.commonService.selectAddressPopupEvent.subscribe((res: any) => {
      if (res) {
        this.openAddressModelInternal(currentPlanDetails);
      }
    });
  }

  openAddressModelInternal(currentPlanDetails: any) {
    let currentIdData: any = currentPlanDetails;
    let className = this.commonService.getClassName('ipm-billing-address-popup-model');
    this.commonService.openModel(this.billingAddressesTemplate, { currentPlanDetails :  currentIdData}, className, true);
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe((response: any) => {
        this.onCloseModelPopup(response, currentPlanDetails);
      });
    } else {
      this.commonService.modelRef.afterClosed().subscribe((response: any) => {
        this.onCloseModelPopup(response, currentPlanDetails);
      });
    }
  }

  onCloseModelPopup(response: any, currentPlanDetails: any = null) {
    if (response && response.actionType === 'OpenAddForm') {
      if (this.addressReopenSubscription) {
        this.addressReopenSubscription.unsubscribe();
        this.addressReopenSubscription = null;
      }
      this.openAddressFormDirect(response.currentDetails || currentPlanDetails);
      return;
    }

    if (response &&  response.actionType === 'Checkout') {
        if (this.addressReopenSubscription) {
          this.addressReopenSubscription.unsubscribe();
          this.addressReopenSubscription = null;
        }
        let data: any = {
          "planId": response.currentDetails.razorpayPlanId,
          "billingAddress": response.selectedAddress._id
        };
        if (this.isCouponApplied && this.couponCode) {
          data['offerCode'] = this.couponCode;
        }
        this.selectedSubsData = response.currentDetails;
        this.createSubscription(data);
        let eventName = "subscription_checkout_initiated"
        let attributes: any = {
          category: 'Beats',
          label: 'Subscription',
          action: 'click',
          selected_subscription_plan: response.currentDetails.planName ,
          value: response.currentDetails.price,
          userRole: this.browserStorageService?.getCurrentRoles || 'guest',
          userId : this.browserStorageService?.getUserId || 'guest'
        };
        this.ga4Tracking.sendEvent(eventName, attributes);
    } else if (response === undefined || response === null) {
      if (this.addressReopenSubscription) {
        this.addressReopenSubscription.unsubscribe();
        this.addressReopenSubscription = null;
      }
    }
  }

  onSelectedAddress(selectedAddress: any) {
    if (selectedAddress) {
      this.currentAddressSelected = selectedAddress.currentBillingAddress;
    }
  }

  /**
   * In this function open Payment gateway
   * @param subscription id
   */
  payWithRazor(subscriptionId: string) {
    const options: any = {
      key: environment.rozarPayDevKey,
      currency: 'INR',
      modal: {
        escape: false,
      },
      method: {
        card: true,
        netbanking: true,
        upi: true
      },
      subscription_id: subscriptionId,
      prefill: {
        "name": this.currentUserInfo.name,
        "email": this.currentUserInfo.email
      }
    };
    options.handler = ((response: any, error:any) => {
      options.response = response;
      this.ngZone.run(() => {
        this.paymentSuccess("coupon", this.selectedSubsData);
        // this.openConfirmationPopup("", "success");
      });
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    rzp.on('payment.failed', (response: any) => {
      this.commonService.showToastErrorMessage('Transaction failed!');
    });
  }

  reLoadPage() {
    window.location.reload()
  }

  /**
   * Pro plan the user can buy straight away ("Upgrade"): any monthly Pro plan, or a Pro plan billed
   * differently from the current one. Anything else goes through "Contact us to upgrade".
   * Shared by the plan cards and the compare table so both show the same button.
   */
  canUpgradeDirectly(plan: SubscriptionModel): boolean {
    return plan?.tier === 'tier2' &&
      (plan?.frequency === 'monthly' || this.activePlanSubscription?.frequency !== plan?.frequency);
  }

  /** True when one of the listed cards is the expanded Pro card (shown inside a padded frame). */
  hasExpandedPlan(plans: Array<SubscriptionModel>): boolean {
    return plans.some(plan => plan.isShowPlan && plan.isExpandPlan);
  }

  /** Number of plan cards actually rendered (hidden plans and the "Without Commission" heading excluded). */
  getVisiblePlanCount(plans: Array<SubscriptionModel>): number {
    return plans.filter(plan => plan.isShowPlan && plan.planName !== 'Without Commission').length;
  }

  onChangeMonthlyPlan() {
    this.preparePlansList("changeToggleEvent");
  }
  changeToggleUsingOfferClick() {
    this.onChangeMonthlyPlan();
  }


  preparePlansList(isToggleChange: string  = "") {
    if (this.AllPlansList.length > 0) {
        const filterList = this.AllPlansList.filter((plan: any) => {
          const isProWithCommission = plan?.tier === "tier2" && plan?.isCommission;
          if (isProWithCommission) {
            return plan?.frequency === this.subsToggle;
          }
          const isAnnual = plan?.frequency === "annual";
          const isNonProPlan = plan?.tier !== "tier2";
          const isProMonthlyWithoutCommission =
            plan?.tier === "tier2" && plan?.frequency === "monthly" && !plan?.isCommission;
          return isAnnual || isNonProPlan || isProMonthlyWithoutCommission;
        });
        this.subsList = this.setSubscriptionList(filterList);
        this.subsList = this.subsList.filter(item => {
          if (this.activePlanSubscription) {
            if (this.activePlanSubscription?.razorpayPlanId === item.razorpayPlanId) {
              item.isActive = true;
            } else {
              item.isActive = false;
            }
            if (item.tier === "tier2") {
              if (this.activePlanSubscription?.tier === "tier1") {
                // Premium subscriber: the Pro (with commission) upgrade card is shown expanded
                if (item.isCommission) {
                  item.isExpandPlan = true;
                }
              } else if (this.activePlanSubscription?.tier === "tier2" && this.activePlanSubscription?.id === item?.id) {
                // active Pro plan (with or without commission) is shown alone, in the expanded view
                item.isExpandPlan = true;
              }
            }
          } else {
            if (this.activatedSubs && !this.activatedSubs.subscriptionTiers.includes('tier1') && !this.activatedSubs.subscriptionTiers.includes('tier2') &&  item?.tier === "tier0") {
              item.isActive = true;
            }
          }
          if (!this.currentUserInfo) {
            item.isShowButton = true;
          }
          return item;
        });
        this.subsList.forEach((plan: any) => {
          if (plan?.tier === "tier2" && plan?.frequency === "monthly" && !plan?.isCommission) {
            plan.isExpandPlan = true;
          }
        });

        // Build compareList: all subsList plans, plus Pro monthly/annual (without commission), no duplicates
        const proPlans = this.AllPlansList.filter(plan => plan.tier === 'tier2' && (plan.frequency === 'monthly' || plan.frequency === 'annual') && plan.isCommission);
        // Add proPlans to subsList if not already present (by razorpayPlanId)
        const subsListIds = this.subsList.map(plan => plan.razorpayPlanId);
        const uniqueProPlans = proPlans.filter(plan => !subsListIds.includes(plan.razorpayPlanId));
        this.compareList = [...this.subsList, ...uniqueProPlans];
      // Load KITS22 data for settings page
      if (this.componentType === 'setting') {
        this.loadKits22Data();
      }      
      this.isLoadData = true;
      setTimeout(() => {
          this.updateCompareScrollbarState();
        });
      this.schedulePlanRowAlignment();
      // Initialize animation after data is loaded and DOM is rendered
      if (!this.componentType) {
        setTimeout(() => {
          this.initializeStatsAnimation();
        }, 200);
      }
    }
  }

  setSubscriptionList(filterList: Array<any>) {
    let filterData: any = []
    if (this.componentType === "popup") {
      filterData = filterList.filter((plan: any) =>  plan?.tier === "tier2")
    } else {
      filterData = filterList;
    }
    return filterData;
  }

  setCouponApi() {
    this.isCouponApplied = true;
    if (this.isCouponApplied &&  this.subsToggle === "annual") {
        this.isCouponApplied = false;
        this.subsList.map(item => {
        if (item.isShowPlan && item.planName !== 'Basic Plan') {
          this.onCloseAppliedPopup(item);
        }
      });
    }
  }

  createSubscription(data: any) {
    this.subscriptionService.createSubscription(data).subscribe((res: any) => {
      this.payWithRazor(res.subscriptionId);
    });
  }

  scrollCompareSection() {
    if (this.componentType === "popup") {
      this.closePopup();
      this.router.navigate(['/subscriptions']);
      setTimeout(() => {
        this.scrollCompareSectionFn();
      }, 500);
    } else {
      this.scrollCompareSectionFn();
    }
  }

  scrollCompareSectionFn() {
    const elementList: any = document.getElementById('compare-plan-section');
    if (elementList) {
      const element = elementList as HTMLElement;
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  openCancelSubscriptionPop(selectedSubs: any) {
    let found = this.activatedSubs.activeSubscriptions.find((item) => item.planId === selectedSubs.razorpayPlanId)
    let sendData = {
      popUpType: 'reset-password',
      message: '',
      subscriptionData: selectedSubs,
      activatedSubsObject: found
    }
    let className = this.commonService.getClassName('ipm-confirmation-popup-model');
    this.commonService.openModel(this.cancelSubscriptionModal, sendData, className, true);
  }

  closeDialog(actionType: string, type: string, currentActiveSubs: any = "",selectedSubscription: any = '', annualUpgrade = "") {
    if (type === 'cancelSub') {
      if (actionType === 'yes') {
        this.cancelSubscriptionApi(currentActiveSubs);
      } else {
        this.commonService.closePopUp();
      }
    } else if (type ===  "contactUs") {
        actionType == 'whatsapp' ? this.commonService.openSupport() : this.commonService.openSupport('email');
    } else if (type === 'upgrade') {
      if (actionType === 'cancelApi') {
        this.cancelSubscriptionApi(currentActiveSubs, type, selectedSubscription);
      } else if (actionType === "cancelUpdate") {
        this.cancelSubscriptionApi(currentActiveSubs, type, selectedSubscription, actionType, annualUpgrade);
      } else {
        this.closePopup();
        this.openAddressModel(selectedSubscription);
      }
    } else if (type === 'purchaseSub') {
      if (actionType === 'yes') {
        this.closePopup();
        this.openAddressModel(selectedSubscription);
      }
    } else {
      this.closePopup();
      this.openAddressModel(selectedSubscription);
    }
  }



  openUpdatePlan(selectedSubs: any, type: string = "") {
    let foundAnnual: any = "";
    let eventName = "subscription_upgrade_initiated"
    let attributes: any = {
      category: 'Beats',
      label: 'Subscription',
      action: 'click',
      selected_subscription_plan: selectedSubs.planName ,
      userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest'
    };
    this.ga4Tracking.sendEvent(eventName, attributes);
    foundAnnual = this.AllPlansList.find(item =>  item.id === selectedSubs.id && item.frequency === selectedSubs.frequency);
    if (this.activePlanSubscription.expiresOnCycleEnd) {
      this.openAddressModel(foundAnnual ? foundAnnual : selectedSubs);
    } else {
      let sendData = {
        popUpType: 'reset-password',
        message: '',
        subscriptionData: selectedSubs,
        activatedSubsObject: this.activePlanSubscription,
        type: type,
        annualUpgrade: foundAnnual
      }
      let className = this.commonService.getClassName('ipm-confirmation-popup-model');
      this.commonService.openModel(this.upgradePlanTemplate, sendData, className, true);
      let eventName = "subscription_upgrade_successful"
      let attributes: any = {
        category: 'Beats',
        label: 'Subscription',
        action: 'click',
        selected_subscription_plan: selectedSubs.planName ,
        userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
        userId : this.browserStorageService?.getUserId() || 'guest'
      };
      this.ga4Tracking.sendEvent(eventName, attributes);
    }
  }

  openConfirmationPopup(selectedSubs: any, type: string = "") {
    let sendData = {
      popUpType: 'reset-password',
      message: '',
      subscriptionData: selectedSubs,
      typeOfConfirmation: type
    }
    let className = this.commonService.getClassName('ipm-confirmation-popup-model');
    this.commonService.openModel(this.confirmationPopTemplate, sendData, className, true);
  }

  openContactUsPlan() {
    let sendData = {
      popUpType: 'reset-password',
      message: ''
    }
    let className = this.commonService.getClassName('ipm-confirmation-popup-model');
    this.commonService.openModel(this.ContactUsSubscriptionTemplate, sendData, className, true);
  }

  cancelSubscriptionApi(currentActiveSubs: any, type: string = "", selectedSubscription: any = "", actionType = "", annualUpgrade= "") {
    this.subscriptionService.cancelSubscriptionEvent(currentActiveSubs.subscriptionId).subscribe((res: any) => {
      this.ga4Tracking.sendEvent('cancel_mandate', {
        category: 'Subscription',
        label: selectedSubscription ? selectedSubscription.planName : '',
        action: 'success',
        Existing_subscription_plan : this.activePlanSubscription.planName,
        userRole: this.browserStorageService?.getCurrentRoles()|| 'guest',
        userId : this.browserStorageService?.getUserId() || 'guest'
      });
      this.markSubscriptionCancelled(currentActiveSubs?.subscriptionId);
      this.commonService.closePopUp();
      this.commonService.showToastSuccess("Your subscription mandate is canceled, but your plan remains active until expiry.");
      if (type && selectedSubscription) {
        if (actionType ===  "cancelUpdate") {
          this.openAddressModel(annualUpgrade ? annualUpgrade : selectedSubscription);
        } else {
          this.openConfirmationPopup(selectedSubscription);
        }
      }
    }, (error) => {
      this.commonService.showToastError(error);
    });
  }

  /**
   * The mandate is cancelled: the plan now runs until the cycle ends. Set the flag everywhere the cancel state is read from, not only
   * on the displayed plan: the shared subscription list (activatedSubs is the same object the navbar and other pages read, and
   * activePlanSubscription is rebuilt from it) and the object the open popup was given, so the "first cancel your current
   * subscription mandate" popup does not show again.
   */
  private markSubscriptionCancelled(subscriptionId: string): void {
    const cancelled = this.activatedSubs?.activeSubscriptions?.find((item) => item.subscriptionId === subscriptionId);
    if (cancelled) {
      cancelled.expiresOnCycleEnd = true;
    }
    if (this.activePlanSubscription) {
      this.activePlanSubscription.expiresOnCycleEnd = true;
    }
  }

  closePopup(type: string = "") {
    if (type) {
      this.commonService.closePopUp();
      this.commonService.showToastSuccess("Transaction successful!");
      setTimeout(() => {
        this.reLoadPage();
      }, 500);
    } else {
      this.commonService.closePopUp();
    }
  }

  dateDiff(first: any, second: any) {
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }

  parseDate(str: any) {
    var mdy = str.split('/');
    return new Date(mdy[2], mdy[0] - 1, mdy[1]);
  }

  openAuthAlertModel() {
    this.commonService.closePopUp();
    let className = this.commonService.isMobileDisableClick ? 'ipm-mobile-non-login-alert-shared-model' : 'ipm-non-login-alert-shared-model';
    this.commonService.openModel(this.loginAlertUserPopup, {}, className, false);
  }

  applyCoupon(planObj: SubscriptionModel) {
    this.subscriptionService.couponValidation(planObj.razorpayPlanId, this.couponCode).subscribe(data => {
      if(data.offerValid) {
        this.onCloseAppliedPopup(planObj);
        this.paymentSuccess("coupon",  planObj);
      } else {
        this.commonService.showToastErrorMessage("This coupon code is invalid.");
      }
    }, (error) => {
      this.commonService.showToastSuccess(error);
    });
  }

  paymentSuccess(type: string, currentPlan: any = "") {
    let sendData = {
      popType: type,
      buttonText: "Close"
    }
    let classNotifyName =  this.commonService.getClassName('ipm-payment-success-popup-model');
    this.commonService.openModel(this.paymentSuccessPopup,sendData,classNotifyName,false);
    const plan = currentPlan && typeof currentPlan === 'object' ? currentPlan : this.subsList.find((item: any) => item.razorpayPlanId === currentPlan);
    const gross = Number(plan?.discountAmount ?? plan?.price ?? 0);
    let eventName = "subscription_checkout_successful"
    let attributes: any = {
      category: 'Beats',
      label: 'Subscription',  
      selected_plan: currentPlan.planName ||'',
      action: 'click',
      transaction_id: currentPlan.razorpayPlanId ||'',
      value : gross|| '',
      currency: 'INR'   ,
      userName: this.currentUserInfo.name,
      userEmail: this.currentUserInfo.email,
      userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest'
    };
    this.ga4Tracking.sendEvent(eventName, attributes);
    this.ga4Tracking.sendEvent('Purchase',attributes); 
    // if (this.commonService.isMobileDisableClick ) {
    //   if (this.commonService.bottomRef) {
    //     this.commonService.bottomRef.afterDismissed().subscribe( res => {
    //       this.onCloseAppliedPopup(currentPlan);
    //     });
    //   }
    // } else {
    //   if (this.commonService.modelRef) {
    //     this.commonService.modelRef.afterClosed().subscribe( res => {
    //       this.onCloseAppliedPopup(currentPlan);
    //     });
    //   }
    // }
     // Subscribe to popup close event for redirect
    // Use commonService.modelRef or bottomRef which are set by openModel()
    if (this.commonService.isMobileDisableClick && this.commonService.bottomRef) {
      this.commonService.bottomRef.afterDismissed().subscribe(() => {
        sessionStorage.setItem('subscriptionSuccess', 'true');
        this.router.navigate(['/subscription-successful']);
      });
    } else if (this.commonService.modelRef) {
      this.commonService.modelRef.afterClosed().subscribe(() => {
        sessionStorage.setItem('subscriptionSuccess', 'true');
        this.router.navigate(['/subscription-successful']);
      });
    }
  }

  onCloseAppliedPopup(currentPlan: any) {
    // this.isCouponApplied = true;
    // this.actualPrice = currentPlan.price;
    let discountAmount = currentPlan.price;
    let totalAmountPercentage = 100 + Number((((discountAmount/currentPlan.price) - 1) * 100).toFixed(2));
    let discountPrice: any = ((currentPlan.price / 100) * totalAmountPercentage).toFixed();
    this.subsList = this.subsList.filter(subData => {
      if (subData.razorpayPlanId === currentPlan.razorpayPlanId) {
        subData['discountAmount'] = discountPrice;
        subData = JSON.parse(JSON.stringify(this.offerTextUpdated(subData)));

      }
      return subData
    });
  }

  offerTextUpdated(currentPlan: any) {
    let discountAmount = currentPlan.price;
    let monthlyPrice = 0;
    let found = this.subscriptionService.annualPlanPrice.find((item: any) =>  item.plan === currentPlan.planName);
    if (found) {
      if (currentPlan.frequency === "monthly") {
        discountAmount = found.amount;
      }
      monthlyPrice = found.monthlyAmount;
    }
    let actualPrice =  0;
    if (currentPlan.frequency === "annual" && currentPlan.tier === "tier1" && currentPlan.price !== 999) {
      actualPrice = currentPlan.actualPrice;
    } else if (currentPlan.frequency === "annual" && currentPlan.tier === "tier1" && currentPlan.price === 999) {
      actualPrice = 3999;
    } else {
      actualPrice =  monthlyPrice * 12;
    }
    let discountPercentage: any =  parseInt((((discountAmount / actualPrice ) - 1 ) * 100).toFixed());
    discountPercentage =  (Math.abs(discountPercentage)).toString();
    let offerText: string = currentPlan['offerText'];
    if (currentPlan.frequency === "monthly" && currentPlan.tier !== "tier1") {
      currentPlan['offerText'] =  offerText.replace("16", currentPlan.isShowBpmOfferSection || currentPlan?.isShowFounderOption ? currentPlan.discountBpmOffer : discountPercentage);
    } else if (currentPlan.frequency === "annual") {
      currentPlan['offerText'] =  offerText.replace("16", currentPlan.isShowBpmOfferSection  || currentPlan?.isShowFounderOption ?  currentPlan.discountBpmOffer : discountPercentage);
    } else {
      currentPlan['offerText'] = "";
    }
    currentPlan['actualAnnualPrice'] = actualPrice;
    if (currentPlan.frequency === "annual") {
      if (currentPlan.tier === "tier1")  {
        currentPlan['bpmAcutalPriceAmmount'] = 3999;
      } else if (currentPlan.tier === "tier2") {
         currentPlan['bpmAcutalPriceAmmount'] = 4999;
      }
    }
    return currentPlan;
  }

  startTime() {
    let next7Date = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    let  countDownDate = new Date(next7Date).getTime();
    this.timerInterval = setInterval(() => {
       // Get today's date and time
      let currentDate = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - currentDate;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      this.timerLeft = days + "d " + hours + "h "
      + minutes + "m " + seconds + "s ";

      // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(this.timerInterval);
        }
    }, 1000)
  }

  clearState() {
    // this.isCouponApplied = false;
    this.couponCode = "";
    this.timerLeft = "";
    // if (this.timerInterval) {
    //   clearInterval(this.timerInterval);
    // }
  }

  /**
 * Set The Browser title and set description
 */
  setBrowsersTitle() {
    let title: any = "Sell Beats | Sell Instrumentals ";
    let setDesc: any  = `Start selling beats online on the illpeoplemusic marketplace`;
    this.commonService.setTitleService(title, setDesc);
  }

  /**
   * Check if user is on PRO Annual plan
   */
  isUserOnProAnnual(): boolean {
    if (!this.activePlanSubscription) return false;
    return this.activePlanSubscription.tier === 'tier2' &&
      this.activePlanSubscription.frequency === 'annual';
  }

  /**
   * Get button text based on user's current plan
   */
  getProAnnualButtonText(): string {
    return this.isUserOnProAnnual() ? 'Current Plan' : 'Upgrade to PRO';
  }

  /**
   * Get the monthly price for a plan's tier/commission combo, used to
   * derive the struck-through "monthly price x 12" shown next to the annual price
   */
  getMonthlyPriceForPlan(currentPlan: any): number {
    const monthlyPlan = this.AllPlansList.find((plan: any) =>
      plan.tier === currentPlan.tier && plan.isCommission === currentPlan.isCommission && plan.frequency === 'monthly');
    return monthlyPlan ? monthlyPlan.price : 0;
  }

    exploreSubsPlan() {
      this.router.navigate(['/subscriptions']);
    }

  /**
   * Load dynamic KITS22 container data
   */
  loadKits22Data() {
    this.kits22Data.isLoading = true;

    this.subscriptionService.getSubscriptionWithCredits()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          const tier = data.subscriptionTiers?.[data.subscriptionTiers.length - 1] || 'tier0';
          // Use the last (most recent) active subscription — after an upgrade, the new plan is appended
          const latestSub = data.activeSubscriptions?.[data.activeSubscriptions?.length - 1];
          const frequency = latestSub?.frequency || 'monthly';
          const isCommission = (data.sellerCommissionPercent || 0) > 0;
          const quota = data.credits?.quota || CreditQuotaHelper.getQuota(tier, frequency, isCommission);
          const balance = data.credits?.balance || 0;

          // For Basic users (tier0), hide details and only show button
          if (tier === 'tier0') {
            this.kits22Data.showDetails = false;
            this.kits22Data.showButton = true;
          } else {
            this.kits22Data.showDetails = true;

            // Set quota label and value based on frequency
            if (frequency === 'annual') {
              this.kits22Data.quotaLabel = 'Yearly Quota:';
              this.kits22Data.quota = `${quota} credits/year`;
              this.kits22Data.renewalCycle = 'Annually';
            } else {
              this.kits22Data.quotaLabel = 'Monthly Quota:';
              this.kits22Data.quota = `${quota} credits/month`;
              this.kits22Data.renewalCycle = 'Monthly';
            }

            this.kits22Data.availableCredits = balance;

            // Hide button only for PRO Annual (tier2 + annual)
            this.kits22Data.showButton = !(tier === 'tier2' && frequency === 'annual');
          }

          this.kits22Data.isLoading = false;
        },
        error: (err: any) => {
          console.error('Failed to load KITS22 data:', err);
          this.kits22Data.isLoading = false;
        }
      });
  }

  ngAfterViewInit() {
    // Animation will be initialized after isLoadData becomes true
    this.updateCompareScrollbarState();
    // web fonts change text heights; align again once they are ready
    (document as any).fonts?.ready?.then(() => this.schedulePlanRowAlignment());
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateCompareScrollbarState();
    this.schedulePlanRowAlignment();
  }

  // ==================== Row alignment across plan columns ====================

  /** Parts of a plan card header, top to bottom; each gets the same height in every card of a row. */
  private readonly PLAN_CARD_PARTS = ['.heading', '.coupon-applied-section', '.amount-section', '.ipm-per-month',
    '.expired-plan-section', '.offer-section', '.royalties-details', '.plans-details'];
  private readonly COMPARE_PARTS = ['.heading', '.amount-section', '.ipm-per-month', '.offer-section', '.button-section', '.plan-details'];
  private alignedElements: HTMLElement[] = [];
  private alignTimer: any;

  /** Re-aligns after Angular has rendered (plan list built, toggle changed, resize, fonts loaded). */
  schedulePlanRowAlignment() {
    clearTimeout(this.alignTimer);
    this.alignTimer = setTimeout(() => this.alignPlanRows(), 60);
  }

  /**
   * Gives every header part and every feature row the same height in all plan columns shown side by side,
   * so plan names, prices, badges, descriptions, feature rows and buttons sit on the same line
   * (plan cards and the compare table). Content differs per plan, so this cannot be done with CSS alone.
   */
  private alignPlanRows() {
    const host = this.hostElement?.nativeElement;
    if (!host) {
      return;
    }
    this.alignedElements.forEach(el => el.style.minHeight = '');
    this.alignedElements = [];
    const isVisible = (el: HTMLElement) => el.offsetWidth > 0;

    const cards = Array.from(host.querySelectorAll<HTMLElement>('.ipm-grid-section > .subs-plans-section')).filter(isVisible);
    // cards in the same grid row end on the same line, margins included (they are stretched to the row height)
    const rows = new Map<number, HTMLElement[]>();
    cards.forEach(card => {
      const key = Math.round(card.getBoundingClientRect().bottom + (parseFloat(getComputedStyle(card).marginBottom) || 0));
      rows.set(key, [...(rows.get(key) ?? []), card]);
    });
    rows.forEach(rowCards => {
      // the expanded Pro card is wrapped in a frame; align its inner card
      const columns = rowCards.map(card => card.querySelector<HTMLElement>(':scope > div:first-child') ?? card);
      this.alignColumns(columns, this.PLAN_CARD_PARTS, '.feature-list .feature-section', '.button-section');
    });

    const compareColumns = Array.from(host.querySelectorAll<HTMLElement>(
      '.plan-compare-section .ipm-label-plan-section, .plan-compare-section .ipm-plan-compare-grid-section .plan-section')).filter(isVisible);
    this.alignColumns(compareColumns, this.COMPARE_PARTS, '.feature-list .feature-section');
  }

  private alignColumns(columns: HTMLElement[], parts: string[], rowSelector: string, footerSelector?: string) {
    if (columns.length < 2) {
      return;
    }
    const groups: HTMLElement[][] = parts.map(part => columns.map(col => col.querySelector<HTMLElement>(part)).filter(Boolean) as HTMLElement[]);
    const rowLists = columns.map(col => Array.from(col.querySelectorAll<HTMLElement>(rowSelector)));
    const rowCount = Math.max(...rowLists.map(list => list.length));
    for (let i = 0; i < rowCount; i++) {
      groups.push(rowLists.map(list => list[i]).filter(Boolean));
    }
    if (footerSelector) {
      groups.push(columns.map(col => col.querySelector<HTMLElement>(footerSelector)).filter(Boolean) as HTMLElement[]);
    }
    // a part whose height depends on its children (e.g. the header block) is measured after its children are aligned
    groups.forEach(group => {
      if (group.length < 2) {
        return;
      }
      const height = Math.max(...group.map(el => el.getBoundingClientRect().height));
      group.forEach(el => {
        el.style.boxSizing = 'border-box';
        el.style.minHeight = `${height}px`;
        this.alignedElements.push(el);
      });
    });
  }

  onCompareGridScroll() {
    if (!this.compareScrollContent) {
      return;
    }
    this.compareScrollValue = this.compareScrollContent.nativeElement.scrollLeft;
  }

  onCompareScrollbarInput(event: Event) {
    if (!this.compareScrollContent) {
      return;
    }
    const value = Number((event.target as HTMLInputElement).value);
    this.compareScrollValue = Number.isFinite(value) ? value : 0;
    this.compareScrollContent.nativeElement.scrollLeft = this.compareScrollValue;
  }

  updateCompareScrollbarState() {
    if (!this.compareScrollContent) {
      this.isCompareScrollbarVisible = false;
      this.compareScrollMax = 0;
      this.compareScrollValue = 0;
      return;
    }
    const compareElement = this.compareScrollContent.nativeElement;
    const maxScrollLeft = Math.max(compareElement.scrollWidth - compareElement.clientWidth, 0);
    this.compareScrollMax = maxScrollLeft;
    this.isCompareScrollbarVisible = maxScrollLeft > 0;
    this.compareScrollValue = Math.min(compareElement.scrollLeft, maxScrollLeft);
  }

  initializeStatsAnimation() {
    if (this.statsSection) {
      this.setupStatsAnimation();
    }
  }

  setupStatsAnimation() {
    this.statsObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.startCountingAnimation();
            if (this.statsObserver) {
              this.statsObserver.disconnect();
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    this.statsObserver.observe(this.statsSection.nativeElement);
  }

  startCountingAnimation() {
    const duration = 3000; // 3 seconds for all animations
    
    this.animatedStats.forEach((stat, index) => {
      const targetNumber = this.extractNumber(stat.title);

      this.animateNumber(0, targetNumber, duration, (currentValue) => {
        this.ngZone.run(() => {
          this.animatedStats[index].displayValue = this.formatNumber(currentValue, stat.title);
        });
      });
    });
  }

  animateNumber(start: number, end: number, duration: number, callback: (value: number) => void) {
    const startTime = performance.now();

    const easeOutQuad = (t: number) => t * (2 - t);

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutQuad(progress);
      const currentValue = start + (end - start) * easedProgress;

      callback(currentValue);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

  extractNumber(str: string): number {
    // Remove commas first for proper parsing
    const cleanStr = str.replace(/,/g, '');
    const match = cleanStr.match(/[\d.]+/);
    if (!match) return 0;

    const num = parseFloat(match[0]);

    if (cleanStr.includes('K')) return num * 1000;
    if (cleanStr.includes('M')) return num * 1000000;
    if (cleanStr.includes('B')) return num * 1000000000;

    return num;
  }

  formatNumber(value: number, originalStr: string): string {
    const hasPlus = originalStr.includes('+');
    const hasCurrency = originalStr.includes('₹');
    const hasComma = originalStr.includes(',');

    let formatted = '';

    if (originalStr.includes('K')) {
      formatted = (value / 1000).toFixed(0) + 'K';
    } else if (originalStr.includes('M')) {
      formatted = (value / 1000000).toFixed(0) + 'M';
    } else if (originalStr.includes('B')) {
      formatted = (value / 1000000000).toFixed(1) + 'B';
    } else {
      formatted = Math.round(value).toString();
      // Always add comma formatting for numbers >= 1000 if original had commas
      if (hasComma) {
        formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }

    if (hasCurrency) formatted = '₹' + formatted;
    if (hasPlus) formatted = formatted + '+';

    return formatted;
  }


  /**
   * Handle the "Upgrade" CTA in the annual offer popup (componentType === 'offer') and the Diwali Pro popup (componentType === 'diwaliOffer').
   * Locates the PRO Annual commissioned plan and drives it straight into the
   * existing billing-address + Razorpay checkout flow via buyPlanAction.
   */
  claimOffer() {
    if (this.isPurchaseDisabled) {
      return;
    }
    const offerPlan = this.AllPlansList.find((plan: SubscriptionModel) =>
      plan.tier === 'tier2' && plan.frequency === 'annual' && plan.isCommission);
    if (!offerPlan) {
      this.commonService.showToastErrorMessage('This offer is currently unavailable.');
      return;
    }
    let eventName = "clicked_claim_offer";
    let attributes: any = {
      category: 'subscription',
      label: this.componentType === 'diwaliOffer' ? 'diwali_offer' : 'offer',
      action: 'click',
      userId: this.browserStorageService?.getUserId() || 'guest',
      userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
    };
    this.ga4Tracking.sendEvent(eventName, attributes);
    this.claimOfferCheckout(offerPlan);
  }

  /**
   * Streamlined checkout for the "Claim Offer" CTA in the annual offer popup.
   * buyPlanAction always stacks the address-selection popup right after the
   * offer popup closes, which reads as an interruption. Here, a user who
   * already has a paid plan still goes through the existing upgrade/contact-us
   * flow (openUpdatePlan), but a first-time purchase skips the address popup
   * entirely when a saved address exists, and jumps straight to Razorpay when
   * the user submits a new one.
   */
  claimOfferCheckout(currentPlanDetails: any) {
    if (!this.currentUserInfo) {
      if (this.componentType === 'diwaliOffer') {
        // guest from the Diwali popup: go to the sign in page, then back to the plans (Diwali Pro card) after login
        this.closePopup();
        // set after the navigation: app.component stores the previous url on every NavigationEnd for guests
        this.router.navigate(['/signin']).then(() => this.browserStorageService.setPreviousRoute('/subscriptions'));
      } else {
        this.openAuthAlertModel();
      }
      return;
    }
    if (this.activePlanSubscription && this.activePlanSubscription.tier !== 'tier0') {
      this.closePopup();
      this.openUpdatePlan(currentPlanDetails, 'upgrade');
      return;
    }
    this.closePopup();
    this.startDirectCheckout(currentPlanDetails);
  }

  startDirectCheckout(currentPlanDetails: any) {
    this.billingAddressService.getBillingAddress().pipe(take(1)).subscribe((addressList: Array<BillingListModel>) => {
      if (addressList && addressList.length > 0) {
        // Most recently added address, matching the default selection used by the address popup
        this.proceedToCheckout(currentPlanDetails, addressList[addressList.length - 1]);
      } else {
        this.openAddressFormDirect(currentPlanDetails);
      }
    }, () => {
      // Fall back to the full address popup flow if the address lookup fails
      this.openAddressModel(currentPlanDetails);
    });
  }

  openAddressFormDirect(currentPlanDetails: any) {
    let className = this.commonService.getClassName('ipm-address-model');
    this.commonService.openModel(AddBillingAddressFormComponent, {}, className, true);
    const ref: any = this.commonService.isMobileDisableClick ? this.commonService.bottomRef : this.commonService.modelRef;
    const instance = ref?.componentInstance || ref?.instance;
    if (instance) {
      instance.countries = this.commonService.getCountriesList();
      instance.dialogType = 'checkoutType';
      instance.currentAddressDetails = {};
      instance.isGuestMode = false;
      if (typeof instance.ngOnInit === 'function') {
        instance.ngOnInit();
      }
    }
    const closeHandler = (response: any) => {
      if (response && response._id) {
        this.proceedToCheckout(currentPlanDetails, response);
      }
    };
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe(closeHandler);
    } else {
      this.commonService.modelRef.afterClosed().subscribe(closeHandler);
    }
  }

  proceedToCheckout(currentPlanDetails: any, billingAddress: any) {
    setTimeout(()=>{
      this.router.navigate(['/subscriptions']);
    },);
    let data: any = {
      "planId": currentPlanDetails.razorpayPlanId,
      "billingAddress": billingAddress._id
    };
    if (this.isCouponApplied && this.couponCode) {
      data['offerCode'] = this.couponCode;
    }
    this.selectedSubsData = currentPlanDetails;
    this.createSubscription(data);
    let eventName = "subscription_checkout_initiated";
    let attributes: any = {
      category: 'Beats',
      label: 'Subscription',
      action: 'click',
      selected_subscription_plan: currentPlanDetails.planName,
      value: currentPlanDetails.price,
      userRole: this.browserStorageService?.getCurrentRoles || 'guest',
      userId: this.browserStorageService?.getUserId || 'guest'
    };
    this.ga4Tracking.sendEvent(eventName, attributes);
  }

  // ==================== Annual Offer Banner Methods ====================

  /**
   * Initialize annual offer banner visibility
   * Shows banner if offer is still active
   */
  initializeOfferBanner() {
    const now = new Date();
    if (now < this.OFFER_END_DATE) {
      this.isOfferBannerVisible = true;
    } else {
      this.isOfferBannerVisible = false;
    }
  }

  ngOnDestroy() {
    clearTimeout(this.alignTimer);
    if (this.statsObserver) {
      this.statsObserver.disconnect();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }


  /** Active platform sale record (dates for the Diwali stripe) */
  get diwaliSale(): any {
    return this.commonService.getActivePlatformSale();
  }

  /** Diwali sale has started (now between the active sale's start_at and end_at). Checked from the sale dates
   *  on every render, not the stored flag, so the Diwali Pro card shows only once the sale starts and hides when it ends */
  get isSaleLive(): boolean {
    return this.commonService.isSaleActive(this.diwaliSale);
  }

  /** Diwali Pro popup "Compare plans": close it and show all the plans */
  openPlansFromOffer(): void {
    this.closePopup();
    this.router.navigate(['/subscriptions']);
  }

  /** User already has a paid plan: the offer popups go through the upgrade flow (claimOfferCheckout) */
  get hasPaidPlan(): boolean {
    return !!this.activePlanSubscription && this.activePlanSubscription.tier !== 'tier0';
  }

  /** Pro annual plan while the Diwali sale is live */
  isDiwaliPro(plan: any): boolean {
    // no "45% off" Pro Annual offer for users who are already on Pro Annual
    return this.isSaleLive && plan?.tier === 'tier2' && plan?.frequency === 'annual' && !plan?.isActive && !this.componentType
      && !this.isUserOnProAnnual();
  }

  /** Per month price of an annual plan ("Just ₹167/month, billed annually"); 0 for free and monthly plans.
   *  The Diwali Pro sale price is the ₹3999 shown on the card. */
  perMonthPrice(plan: any): number {
    if (!plan || plan.frequency !== 'annual') {
      return 0;
    }
    const yearly = this.isDiwaliPro(plan) ? 3999 : Number(plan.price) || 0;
    return yearly > 0 ? Math.round(yearly / 12) : 0;
  }

  /** The compare table has a Pro Annual column with the Diwali offer (the other columns leave room for its struck-through price) */
  get hasDiwaliCompare(): boolean {
    return this.compareList.some(plan => plan.isShowPlan && this.isDiwaliPro(plan));
  }

  /** Diwali card look (gold hover background, fireworks): the sale Pro card, also when it is the active plan */
  isDiwaliCard(plan: any): boolean {
    return this.isDiwaliPro(plan) || (this.isSaleLive && !!plan?.isActive && !this.componentType && (plan?.tier === 'tier2' || /pro/i.test(plan?.planName || '')));
  }

  goToEnrollSale(): void {
    this.router.navigate(['/enroldiwalisale']);
  }
}
